import React from "react";
import Register from "../../components/auth/Register";

function RegisterPage() {
  return <Register />;
}

export default RegisterPage;
